/**
 * /frontend/src/features/analytics/components/appointments/BookingVolumeTrendChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import TrendLineChart from '../charts/TrendLineChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Booking volume trend chart.
 * @param {{data:Array<any>}} props
 * @returns {JSX.Element}
 */
const BookingVolumeTrendChart = ({ data }) => {
  const lines = useMemo(() => ([
    { key: 'booked', label: 'Booked', color: CHART_COLORS.accent },
    { key: 'completed', label: 'Completed', color: CHART_COLORS.success },
    { key: 'noShows', label: 'No-shows', color: CHART_COLORS.warning },
    { key: 'cancellations', label: 'Cancelled', color: CHART_COLORS.danger }
  ]), []);

  return (
    <ChartContainer title="Appointment Trend" subtitle="Bookings and outcomes over time">
      <TrendLineChart data={data} xKey="label" lines={lines} />
    </ChartContainer>
  );
};

export default BookingVolumeTrendChart;

